import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPaymentType, EmptyString, FormTypeAdd, FormTypeEdit, MenuPaymentId, MenuPaymentSubConId } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckUserMenuAccess, ApiCreatePaymentSubCon, ApiDeletePaymentSubCon, ApiGetClientListSubCon, ApiGetPaymentByIdSubCon, ApiUpdatePaymentSubCon } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import { GetPaymentType, GetStatus, money } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import DatePicker from "components/Input/DatePicker";
import ImageIcon from "assets/icon/ImageIcon";

export default function PaymentSubConForm(){
    let navigate = useNavigate()

    const { fetch: getClientList } = useFetch(ApiGetClientListSubCon)
    const { fetch: insertPayment } = useFetch(ApiCreatePaymentSubCon)
    const { fetch: updatePayment } = useFetch(ApiUpdatePaymentSubCon)
    const { fetch: getPaymentById } = useFetch(ApiGetPaymentByIdSubCon)
    const { fetch: deletePayment } = useFetch(ApiDeletePaymentSubCon)
    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramPaymentId = queryString.get("paymentId")

    const [projectId, setProjectId] = useState(EmptyString)
    const [clientOptions, setClientOptions] = useState([])
    const [clientName, setClientName] = useState(EmptyString)
    const [paymentDate, setPaymentDate] = useState(EmptyString)
    const [paymentType, setPaymentType] = useState(EmptyString)
    const [paymentTypeOptions, setPaymentTypeOptions] = useState([])
    const [amount, setAmount] = useState(EmptyString)
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [projectData, setProjectData] = useState([])
    const [allowDelete, setAllowDelete] = useState(false)
    const [allowUndelete, setAllowUndelete] = useState(false)
    const [tempPaymentOptions, setTempPaymentOptions] = useState([])

    const [errorProjectId, setErrorProjectId] = useState(false)
    const [errorPaymentDate, setErrorPaymentDate] = useState(false)
    const [errorPaymentType, setErrorPaymentType] = useState(false)
    const [errorAmount, setErrorAmount] = useState(false)
    const [errorPaymentSlip, setErrorPaymentSlip] = useState(false)
    
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    const projectIdChange = (e) => {
        setProjectId(e.value)
        fGetPaymentTypeList(e.value)
    }
    const paymentDateChange = (e) => {setPaymentDate(e)}
    const paymentTypeChange = (e) => {
        setPaymentType(e.value)
        fGetAmount(e.value)
    }
    const amountChange = (e) => {setAmount(money(e.target.value))}

    const handleChange = (e) => {
        setFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }

    const saveBtnClick = () => {
        if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fCreatePayment().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdatePayment(paramPaymentId).then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = (status, projectId, paymentType) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})
            
            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeletePayment(paramPaymentId, stat, projectId, paymentType).then(() => {
                fGetPaymentById(paramPaymentId).then(() => {
                    setLoading({isOpen: false})
                })
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        setLoading({isOpen: true})
        
        fCheckUserAccess(localStorage.getItem("Id"), MenuPaymentSubConId, localStorage.getItem("CompanyId")).then((res) => {
            if(res.access){
                setPaymentDate(new Date())

                if (formType === FormTypeAdd){  
                    setLoading({isOpen: true})

                    fGetClientList().then(() => {
                        setLoading({isOpen: false})
                    })
                }else if (formType === FormTypeEdit){
                    if(res.edit){
                        setLoading({isOpen: true})

                        fGetPaymentById(paramPaymentId).then(() => {
                            setLoading({isOpen: false}) 
                        })
                    }else{
                        navigate("/access-denied")
                    }
                }            
                
                if(res.delete){
                    setAllowDelete(true)
                }
                if(res.unDelete){
                    setAllowUndelete(true)
                }                
            }else{
                navigate("/access-denied")
            }
        })
    }, [])

    // Function Api Call
    async function fGetPaymentById(paramPaymentId){
        await getPaymentById({
            data: {
                paymentId: paramPaymentId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setProjectId(data.projectId)
                setClientName(data.clientName)
                setPaymentDate(data.paymentDate)
                setPaymentType(data.paymentType)
                setAmount(money(data.amount))
                if (data.photoUrl !== null || data.photoUrl !== EmptyString){
                    setFileUrl(data.photoUrl)
                }
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCreatePayment(){
        let data = new FormData()
        data.append('ProjectId', projectId)
        data.append('PaymentDate', moment(paymentDate).format("yyyy-MM-DD"))
        data.append('PaymentType', paymentType)
        data.append('Amount', amount.replaceAll(",", ""))
        data.append('PhotoUrl', EmptyString)
        data.append('Photo', file)

        await insertPayment({
            data: data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company/payment-subcontractor") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdatePayment(paramPaymentId){
        let data = new FormData()
        data.append('PaymentId', paramPaymentId)
        data.append('ProjectId', projectId)
        data.append('PaymentDate', moment(paymentDate).format("yyyy-MM-DD"))
        data.append('PaymentType', paymentType)
        data.append('Amount', amount === EmptyString ? 0 : amount.replaceAll(",", ""))
        data.append('PhotoUrl', EmptyString)
        data.append('Photo', file)

        await updatePayment({
            data: data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company/payment-subcontractor") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeletePayment(paymentId, status, projectId, paymentType){
        await deletePayment({
            data: {
                paymentId: paymentId,
                status: status,
                projectId: projectId,
                paymentType: paymentType
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/company/payment-subcontractor")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetClientList(){
        await getClientList({
            data: {
                companyId: localStorage.getItem("CompanyId")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setProjectData(response.data)

                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].clientName + ' - ' + response.data[i].projectLocation, value: String(response.data[i].projectId) })
                }

                setClientOptions(tempArray)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }

    function fGetPaymentTypeList(selectedProjectId){
        let tempArray = []

        if(projectData.length > 0){
            for(let i = 0; projectData.length > i; i++){
                if(projectData[i].projectId == selectedProjectId){
                    let paymentTypeList = projectData[i].paymentType

                    tempArray.push({ label: "Select payment type", value: "" })

                    for (let i = 0; i < paymentTypeList.length; i++){
                        tempArray.push({ label: paymentTypeList[i].value, value: String(paymentTypeList[i].id) })
                    }

                    setTempPaymentOptions(paymentTypeList)
                    setPaymentTypeOptions(tempArray)
                    setPaymentType(tempArray[0].value)
                }
            }
        }
    }
    function fGetAmount(selectedPaymentType){
        if(tempPaymentOptions.length > 0){
            for(let i = 0; tempPaymentOptions.length > i; i++){
                if(tempPaymentOptions[i].id == selectedPaymentType){
                    setAmount(money(tempPaymentOptions[i].terminValue))
                }
            }
        }
    }

    // Function
    function fFormValidation(){
        let errorCount = 0
        
        if (projectId === EmptyString || projectId === null){
            setErrorProjectId(true)
            errorCount++
        }else{
            setErrorProjectId(false)
        }
        if (paymentDate === EmptyString || paymentDate === null){
            setErrorPaymentDate(true)
            errorCount++
        }else{
            setErrorPaymentDate(false)
        }
        if (paymentType === EmptyString || paymentType === null){
            setErrorPaymentType(true)
            errorCount++
        }else{
            setErrorPaymentType(false)
        }
        if (amount === EmptyString || amount === null){
            setErrorAmount(true)
            errorCount++
        }else{
            setErrorAmount(false)
        }
        if (formType === FormTypeAdd){
            if (fileUrl === null || fileUrl === EmptyString){
                setErrorPaymentSlip(true)
                errorCount++
            }else{
                setErrorPaymentSlip(false)
            }
        }
        
        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Payment Detail Sub Contractor</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Client Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Client Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <Dropdown className={`${formType === FormTypeAdd ? '' : 'hidden'}`} options={clientOptions} value={projectId} onChange={projectIdChange} />
                            <input className={`input ${formType === FormTypeAdd ? 'hidden' : ''}`} value={clientName} disabled={true} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorProjectId ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Client Name is required!</span>
                    </div>
                </div>

                {/* Payment Date */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Payment Date</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <DatePicker className="w-full h-[42px] bg-white" value={paymentDate} onChange={paymentDateChange} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorPaymentDate ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Payment Date is required!</span>
                    </div>
                </div>

                {/* Payment Type */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Payment Type</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <Dropdown className={`${formType === FormTypeAdd ? '' : 'hidden'}`} options={paymentTypeOptions} value={paymentType} onChange={paymentTypeChange} placeholder={"Select payment type"} />
                            <input className={`input ${formType === FormTypeAdd ? 'hidden' : ''}`} value={GetPaymentType(paymentType)} disabled={true} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorPaymentType ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Payment Type is required!</span>
                    </div>
                </div>

                {/* Amount */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Amount</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="flex items-center w-full sm:w-72">
                            <div className="px-4 py-2 bg-slate-200 rounded-l-md border-l border-y">
                                <span>Rp</span>
                            </div>
                            <input className="px-4 py-2 rounded-r-md w-full border-r border-y border-app-light-grey text-right" value={amount} onChange={amountChange} disabled={true   } />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorAmount ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Amount is required!</span>
                    </div>
                </div>

                {/* Payment Slip */}
                <div>
                    <div className="flex flex-col sm:flex-row ">
                        <div className="w-48 mt-2">
                            <span>Payment Slip</span>
                        </div>
                        <div className="px-4 hidden sm:block mt-2">
                            <span>:</span>
                        </div>
                        
                        <div className="w-full sm:w-72 flex flex-col gap-2">
                            <img className="w-full h-[180px] object-cover mx-auto border rounded-md" src={fileUrl} alt="ID" />
                            <input className="hidden" id="selectedFile" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleChange} />
                            <button onClick={() => document.getElementById('selectedFile').click()} 
                                className="px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                            >
                                <ImageIcon />
                                Add Image
                            </button>
                        </div>
                    </div>
                    <div className={`flex items-center ${errorPaymentSlip ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Payment Slip is required!</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={() => {deleteBtnClick(status, projectId, paymentType)}} visible={formType === FormTypeEdit ? (status === 1 ? (allowDelete ? true : false) : false) : false} />
                <UnDeleteButton onClick={() => {deleteBtnClick(status)}} visible={formType === FormTypeEdit ? (status === 2 ? (allowUndelete ? true : false) : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}